import { WarehouseItemPhotoAction } from "@redotech/crdb-enums/fulfillment/warehouse-item-photo-action";
import {
  DEFAULT_STEP_PHOTO_COUNT,
  MAX_ITEM_PHOTO_CAPTURES,
} from "@redotech/redo-fulfillment-common/item-photo-limits";
import {
  photoInstructionsIdFormat,
  photoInstructionStepIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";
import { PhotoInstructionsSchema } from "./item-work-request-types";

export const listPhotoInstructions = {
  name: "listPhotoInstructions" as const,
  input: z.object({}),
  output: z.object({ instructions: z.array(PhotoInstructionsSchema) }),
};

/** Creates when `id` is absent, replaces the set and its steps when present. */
export const savePhotoInstructions = {
  name: "savePhotoInstructions" as const,
  input: z.object({
    id: photoInstructionsIdFormat.schema.nullish(),
    description: z.string().min(1),
    action: z.enum(WarehouseItemPhotoAction),
    steps: z
      .array(
        z
          .object({
            id: photoInstructionStepIdFormat.schema.nullish(),
            guidance: z.string(),
            examplePhotoUrl: z.string().nullish(),
            /** Defaults to {@link DEFAULT_STEP_PHOTO_COUNT}. */
            minPhotos: z
              .number()
              .int()
              .min(0)
              .max(MAX_ITEM_PHOTO_CAPTURES)
              .optional(),
            /** Defaults to {@link DEFAULT_STEP_PHOTO_COUNT}. */
            maxPhotos: z
              .number()
              .int()
              .min(1)
              .max(MAX_ITEM_PHOTO_CAPTURES)
              .optional(),
          })
          .refine(
            (step) =>
              (step.minPhotos ?? DEFAULT_STEP_PHOTO_COUNT) <=
              (step.maxPhotos ?? DEFAULT_STEP_PHOTO_COUNT),
            { message: "minPhotos must not exceed maxPhotos" },
          ),
      )
      // Otherwise no capture could ever satisfy every step under the cap.
      .refine(
        (steps) =>
          steps.reduce(
            (total, step) =>
              total + (step.minPhotos ?? DEFAULT_STEP_PHOTO_COUNT),
            0,
          ) <= MAX_ITEM_PHOTO_CAPTURES,
        {
          message: `Steps may require at most ${MAX_ITEM_PHOTO_CAPTURES} photos in total`,
        },
      ),
  }),
  output: z.object({ instructions: PhotoInstructionsSchema }),
};

export const deletePhotoInstructions = {
  name: "deletePhotoInstructions" as const,
  input: z.object({ id: photoInstructionsIdFormat.schema }),
  output: z.null(),
};
